/* assets/vh-h2-themen.js — WP-P41 Paket T (02.10.2026, N-Z12). Hebt die Themenwelten-Kachelreihe
   nach dem Laden auf das ARIA-Tab-Pattern (role=tablist/tab/tabpanel, Pfeiltasten-Navigation,
   APG-konform) — ohne JS bleiben die Kacheln ein role="list" aus normalen Links (serverseitig in
   sections/vh-h2-themen.liquid gerendert) und Welt 1 ist sichtbar. Ein Klick auf eine INAKTIVE
   Kachel wechselt nur die Welt (kein Seitenwechsel). Ein Klick auf die BEREITS aktive Kachel oder
   auf den Sekundär-Button "Alle N Produkte: ..." navigiert regulär zur Collection (kein
   preventDefault). Mehrere Sektionsinstanzen (data-vh-h2-themen) werden unabhängig voneinander
   initialisiert. */
(function () {
  'use strict';

  function init(root) {
    var list = root.querySelector('[data-vh-h2-themen-tabs]');
    if (!list) return;
    var tabs = Array.prototype.slice.call(list.querySelectorAll('[data-vh-h2-themen-tab]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-vh-h2-themen-panel]'));
    if (!tabs.length || !panels.length) return;

    // Progressive enhancement: erst jetzt auf das Tab-Pattern umstellen.
    list.setAttribute('role', 'tablist');
    tabs.forEach(function (tab, i) {
      tab.setAttribute('role', 'tab');
      tab.removeAttribute('role-list-item');
      tab.setAttribute('tabindex', tab.classList.contains('is-active') ? '0' : '-1');
    });

    function activate(index, moveFocus) {
      tabs.forEach(function (tab, i) {
        var active = i === index;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
        tab.setAttribute('tabindex', active ? '0' : '-1');
      });
      panels.forEach(function (panel, i) {
        if (i === index) panel.removeAttribute('hidden');
        else panel.setAttribute('hidden', 'hidden');
      });
      if (moveFocus && tabs[index]) tabs[index].focus();
    }

    tabs.forEach(function (tab, index) {
      tab.addEventListener('click', function (e) {
        if (!tab.classList.contains('is-active')) {
          e.preventDefault();
          activate(index, false);
        }
        // bereits aktive Kachel: kein preventDefault -> regulärer Link zur Collection.
      });
      tab.addEventListener('keydown', function (e) {
        var cur = tabs.indexOf(tab);
        var next = null;
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') next = (cur + 1) % tabs.length;
        else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') next = (cur - 1 + tabs.length) % tabs.length;
        else if (e.key === 'Home') next = 0;
        else if (e.key === 'End') next = tabs.length - 1;
        if (next !== null) {
          e.preventDefault();
          activate(next, true);
        }
      });
    });
  }

  var roots = document.querySelectorAll('[data-vh-h2-themen]');
  roots.forEach ? roots.forEach(init) : Array.prototype.forEach.call(roots, init);
})();
